"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const discreteHeaderBannerInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Header Title",
  },
  {
    name: "description",
    type: "string",
  },
  {
    name: "backgroundImage",
    friendlyName: "Background Image",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "linkLabel",
    friendlyName: "Link Label",
    type: "string",
  },
  {
    name: "linkHref",
    friendlyName: "Link URL",
    type: "url",
  },
  {
    name: "theme",
    friendlyName: "Theme for text",
    type: "string",
    enum: [
      { label: "Dark", value: "dark" },
      { label: "Light", value: "light" },
    ],
    defaultValue: "dark",
  },
] as const satisfies Inputs;

export const DiscreteHeaderBannerComponent: RegisteredComponent = {
  name: "DiscreteHeaderBanner",
  component: dynamic(async () =>
    withValidation(
      discreteHeaderBannerInputs,
      (await import("./DiscreteHeaderBanner")).DiscreteHeaderBanner,
      "DiscreteHeaderBanner"
    )
  ),
  inputs: discreteHeaderBannerInputs,
};
